module.exports = __webpack_public_path__ + "img/experiential-learning.b780803d.jpg";